import { useMutation, gql } from '@apollo/client';

import { GET_INTERVIEW_TYPES } from './get-interview-types.hook';

export const DELETE_INTERVIEW_TYPE = gql`
  mutation deleteInterviewType($interviewTypeId: ObjectId!) {
    deleteInterviewType(interviewTypeId: $interviewTypeId)
  }
`;

export const useDeleteInterviewType = () => {
  const [deleteInterviewType] = useMutation(DELETE_INTERVIEW_TYPE, {
    refetchQueries: [GET_INTERVIEW_TYPES],
  });

  return deleteInterviewType;
};
